import { connect } from "react-redux";
import ConnectedClientsPage from "./client/client-list/ClientsPage";
import NewClientPage from "./client/client-list/NewClientPage";
import ConnectedClientViewPage from "./client/client-view/ClientView";
import { routeNames } from "./common/routes";
import DashboardPage from "./dashboard/DashboardPage";
import ConnectedLocationsPage from "./location/LocationsPage";
import ConnectedNewLocationPage from "./location/NewLocationPage";
import ConnectedLocationViewPage from "./location/location-view/LocationView";
import { ConnectedMaterialsPage } from "./materials/MaterialsPage";
import ConnectedNewMaterialPage from "./materials/NewMaterialPage";
import ConnectedNotificationsPage from "./notifications/NotificationsPage";
import ConnectedForgotPasswordPage from "./forgot-password/ForgotPasswordPage";
import ConnectedOnboardingPage from "./onboarding/OnboardingPage";
import ConnectedEditProjectPage from "./project/EditProjectPage";
import ConnectedNewProjectPage from "./project/NewProjectPage";
import ConnectedProjectViewPage from "./project/ProjectViewPage";
import ConnectedProjectsPage from "./project/ProjectsPage";
import ConnectedNewServicePage from "./services/NewServicePage";
import ConnectedServiceViewPage from "./services/ServiceView";
import { ConnectedServicesPage } from "./services/ServicesPage";
import NewTicketPage from "./ticket/NewTicketPage";
import { ConnectedTicketsPage } from "./ticket/TicketsPage";
import UpdateTicketPage from "./ticket/UpdateTicketPage";
import ConnectedTicketViewPage from "./ticket/ticket-view/TicketView";
import NewTurbinePage from "./turbine/NewTurbinePage";
import ConnectedTurbinesPage from "./turbine/TurbinesPage";
import ConnectedTurbineViewPage from "./turbine/turbine-view/TurbineView";
import type { RouteState } from "../types/router";
import ConnectedNewUserPage from "./user-management/NewUserPage";
import { ConnectedUsersPage } from "./user-management/UsersPage";
import LoginPage from "./LoginPage";
import ConnectedSetPasswordPage from "./set-password/SetPasswordPage";
import ConnectedUserPage from "./UserPage";
import type { RootState } from "./store";
import ConnectedUserProfilePage from "./user-profile/UserProfilePage";
import ConnectedEditUserProfilePage from "./user-profile/EditUserProfilePage";
import ConnectedPageErrorPage from "./PageErrorPage";
import type { PageLoadError } from "../features/page-status/pageStatusSlice";

export const routes: Record<string, React.ReactNode> = {
	[routeNames.TICKET_LIST]: <ConnectedTicketsPage />,
	[routeNames.TICKET_CREATE]: <NewTicketPage />,
	[routeNames.TICKET_EDIT]: <UpdateTicketPage />,
	[routeNames.TICKET_VIEW]: <ConnectedTicketViewPage />,
	[routeNames.CLIENT_LIST]: <ConnectedClientsPage />,
	[routeNames.CLIENT_CREATE]: <NewClientPage />,
	[routeNames.CLIENT_EDIT]: <NewClientPage />,
	[routeNames.CLIENT_VIEW]: <ConnectedClientViewPage />,
	[routeNames.TURBINE_LIST]: <ConnectedTurbinesPage />,
	[routeNames.TURBINE_CREATE]: <NewTurbinePage />,
	[routeNames.TURBINE_EDIT]: <NewTurbinePage />,
	[routeNames.TURBINE_VIEW]: <ConnectedTurbineViewPage />,
	[routeNames.USER_LOGIN]: <LoginPage />,
	[routeNames.USER_ONBOARDING]: <ConnectedOnboardingPage />,
	[routeNames.USER_SET_PASSWORD]: <ConnectedSetPasswordPage />,
	[routeNames.USER_FORGOT_PASSWORD]: <ConnectedForgotPasswordPage />,
	[routeNames.USER_CURRENT]: <ConnectedUserPage />,
	[routeNames.DASHBOARD]: <DashboardPage />,
	[routeNames.LOCATION_LIST]: <ConnectedLocationsPage />,
	[routeNames.LOCATION_CREATE]: <ConnectedNewLocationPage />,
	[routeNames.LOCATION_EDIT]: <ConnectedNewLocationPage />,
	[routeNames.LOCATION_VIEW]: <ConnectedLocationViewPage />,
	[routeNames.USER_LOGOUT]: null,
	[routeNames.USER_PROFILE_VIEW]: <ConnectedUserProfilePage />,
  	[routeNames.USER_PROFILE_EDIT]: <ConnectedEditUserProfilePage />,
	[routeNames.SETTINGS_USER_LIST]: <ConnectedUsersPage />,
	[routeNames.SETTINGS_USER_CREATE]: <ConnectedNewUserPage />,
	[routeNames.SETTINGS_USER_EDIT]: <ConnectedNewUserPage />,
	[routeNames.SETTINGS_MATERIAL_LIST]: <ConnectedMaterialsPage />,
	[routeNames.SETTINGS_MATERIAL_CREATE]: <ConnectedNewMaterialPage />,
	[routeNames.SETTINGS_MATERIAL_EDIT]: <ConnectedNewMaterialPage />,
	[routeNames.SETTINGS_SERVICE_LIST]: <ConnectedServicesPage />,
	[routeNames.SETTINGS_SERVICE_CREATE]: <ConnectedNewServicePage />,
	[routeNames.SETTINGS_SERVICE_EDIT]: <ConnectedNewServicePage />,
	[routeNames.SETTINGS_SERVICE_VIEW]: <ConnectedServiceViewPage />,
	[routeNames.PROJECT_LIST]: <ConnectedProjectsPage />,
	[routeNames.PROJECT_CREATE]: <ConnectedNewProjectPage />,
	[routeNames.PROJECT_EDIT]: <ConnectedEditProjectPage />,
	[routeNames.PROJECT_VIEW]: <ConnectedProjectViewPage />,
	[routeNames.NOTIFICATIONS]: <ConnectedNotificationsPage />,
};

type LandingProps = {
	router: RouteState | null;
	loadError: PageLoadError | null;
};

const LandingPage: React.FC<LandingProps & React.PropsWithChildren> = (
	props,
) => {
	const { router, loadError } = props;
	const currentPath = router?.name;
	if (loadError && loadError.routePath === router?.path) {
		return <ConnectedPageErrorPage status={loadError.status} />;
	}
	if (currentPath && currentPath in routes) {
		return <>{routes[currentPath]}</>;
	}
	return <ConnectedPageErrorPage status={404} />;
};

export const ConnectedLandingPage = connect((state: RootState) => ({
	router: state.router.route,
	loadError: state.pageStatus.loadError,
}))(LandingPage);

export default ConnectedLandingPage;
